import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'components/Icon/Icon';
import LocationInput from 'components/LocationInput/LocationInput';

import styles from './LocationFilter.module.scss';

const LocationFilter = ({
  currentLocation,
  googleAPIType,
  locationInputId,
  onBlur,
  onLocationReset,
  onLocationChange,
  placeholder,
  shouldClearOnBlur,
  showResetIcon,
}) => (
  <div className={styles.locationContainer}>
    <Icon className={styles.locationIcon} icon="&#xe694;" />
    <div className={styles.locationInputContainer}>
      <LocationInput
        className={styles.locationInput}
        clearFilter={onLocationReset}
        containerClass={styles.locationInputContainer}
        defaultValue={currentLocation}
        googleAPIType={googleAPIType}
        id={locationInputId}
        onBlur={onBlur}
        placeholder={placeholder}
        shouldClearOnBlur={shouldClearOnBlur}
        showResetIcon={showResetIcon}
        onChangePlace={onLocationChange}
      />
    </div>
  </div>
);

LocationFilter.propTypes = {
  currentLocation: PropTypes.string,
  googleAPIType: PropTypes.string,
  locationInputId: PropTypes.string,
  placeholder: PropTypes.string,
  shouldClearOnBlur: PropTypes.bool,
  showResetIcon: PropTypes.bool,
  onBlur: PropTypes.func,
  onLocationReset: PropTypes.func,
  onLocationChange: PropTypes.func,
};

export default LocationFilter;
